import Debug from '../helpers/debug.js';
import { baseApiBuilder } from '../helpers/baseBuilder.js';
import { jobs } from './jobs/index.js';

const debug = Debug('commands:jobs');
const command = 'jobs <action>';

const desc = 'Manage ETL jobs';

const builder = async function (yargs) {
  debug('builder', command);
  const base = await baseApiBuilder(yargs);
  return base.command(jobs);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
